/**
 * 页面返回组件
 */
import React, { FC, memo } from 'react'
import { getPlatform, miniAppRouteTo, useHistoryNew } from '@utils'
import pageBack from '@img/pageBack.png'
import { themeMobx } from '@mobxStore'
import './index.scss'

interface IProps {
  onClick?: () => void;
  top?: number;
}

const BackPageBtn: FC<IProps> = ({ top = 0, onClick }) => {
  const { isWeixinMiniProgram, isAliPayMiniProgram } = getPlatform()
  const history = useHistoryNew()
  const handle = () => {
    const prevState = history.getPrevState()
    if (onClick) {
      onClick()
    } else {
      if (prevState) {
        history.goBack()
      } else {
        const hasHome = themeMobx?.showTabs?.find(item => item.type === 'home')
        if (hasHome && hasHome.isShow !== 0) {
          if (isWeixinMiniProgram || isAliPayMiniProgram) {
            miniAppRouteTo('/pages/home/index')
          } else {
            history.push('/home')
          }
        } else {
          history.push('/menu')
        }
      }
    }
  }

  return (
    <div
      className='back-page-callback-btn'
      data-cypid='backPageClose'
      style={{ top: `${top + 16}px` }}
      onClick={handle}
    >
      <img className='back-img' src={pageBack} />
    </div>
  )
}

export default memo(BackPageBtn)
